import { Theme } from '@emotion/react';
import { Grid, SxProps, Typography } from '@mui/material';

const checkedSx: SxProps<Theme> = (theme) => ({
	color: 'green',
	marginRight: '5px',
	fontSize: 'var(--font-size-caption)',
	'&::before': {
		content: '"\\2713"',
	},
});

const uncheckedSx: SxProps<Theme> = (theme) => ({
	color: 'red',
	marginRight: '5px',
	fontSize: 'var(--font-size-caption)',
	'&::before': {
		content: '"\\2716"',
	},
});

const disclaimer: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-caption)',
});

const validationsContainer: SxProps<Theme> = (theme) => ({
	display: 'flex',
	flexDirection: 'row',
});

const containerSx: SxProps<Theme> = (theme) => ({
	position: 'relative',
});

const containerMobSx: SxProps<Theme> = (theme) => ({
	position: 'relative',
});

interface Validations {
	Mayus: boolean;
	Number: boolean;
	Length: boolean;
	isMobile: boolean;
}

export const PasswordValidations = ({
	validations: { Mayus, Number, Length, isMobile },
}: {
	validations: Validations;
}) => {
	const classLength = Length ? checkedSx : uncheckedSx;
	const classMayus = Mayus ? checkedSx : uncheckedSx;
	const classNumber = Number ? checkedSx : uncheckedSx;
	const container = !isMobile ? containerSx : containerMobSx;

	return (
		<Grid sx={container}>
			<Typography sx={disclaimer}>{'Tu contraseña debe tener mínimo'}</Typography>
			<Grid sx={validationsContainer}>
				<Typography sx={classMayus}>{'1 mayúscula,'}</Typography>
				<Typography sx={classNumber}>{'1 número,'}</Typography>
				<Typography sx={classLength}>{'8 caractéres'}</Typography>
			</Grid>
		</Grid>
	);
};
